import React from 'react';

import { useTranslationContext } from '@/core/lib/translation/translation.context';

interface DonationDescriptionProps {
  description: string | undefined | null;
}

const DonationDescription: React.FC<DonationDescriptionProps> = ({ description }) => {
  const { t } = useTranslationContext(['common']);

  if (!description) {
    return null;
  }

  return (
    <section className="space-y-2 lg:space-y-1">
      <h2 className="text-body-primary font-semibold text-content-primary">{t('components.donation.details.description.title', { ns: 'common' })}</h2>
      <p className="text-body-secondary overflow-hidden text-ellipsis whitespace-break-spaces font-normal text-content-primary">{description}</p>
    </section>
  );
};

export default DonationDescription;
